import { BodyText, Flex } from '@kijiji/ui'
import { Form as FormikForm } from 'formik'
import styled from 'styled-components'

import { Button } from '@/ui/atoms/button'
import { Drawer as BaseDrawer } from '@/ui/atoms/drawer'

export const StyledRequestViewingButton = styled(Button)(
  ({ theme }) => `
  display: flex;
  gap: ${theme.spacing.default};
  justify-content: flex-start;
  padding: 1rem ${theme.spacing.defaultSmall};
`
)

// Drawer
export const Drawer = styled(BaseDrawer)`
  padding: 0 !important;
`

export const DrawerFlexFormContainer = styled(Flex)(
  ({ theme }) => `
  overflow-y: auto;
  padding-top: ${theme.spacing.giant};
`
)

// Modal
export const ModalFlexFormContainer = styled(Flex)(
  ({ theme }) => `
  border-top: .1rem solid ${theme.colors.grey.light4};
  overflow-y: auto;
  padding-top: ${theme.spacing.default};
`
)

// Form
export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
`

export const FormListingTitleText = styled(BodyText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FormFooter = styled.footer(
  ({ theme }) => `
  border-top: .1rem solid ${theme.colors.grey.light4};
  padding: ${theme.spacing.default} ${theme.spacing.xLarge} ${theme.spacing.default};
`
)

export const FormBodyFlexContainer = styled(Flex)(
  ({ theme }) => `
   overflow-y: auto;
   padding: 0 ${theme.spacing.xLarge} ${theme.spacing.default};
`
)
